<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">

    <div class="form-section">
      <app-form-row
        [label]="['FORMS.ARTICLE.MNR', 'FORMS.ARTICLE.EAN'] | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-input
              [type]="'text'"
              [mainForm]="articleForm"
              [controlName]="'mnr'"
              [placeholder]="mnrPlaceholder"
              [ngClass]="{'placeholder-through': mnrPlaceholder !== ''}"
              datatestid="articleNumberInput"
            ></app-input>
          </div>
          <div class="col-6">
            <app-input
              [type]="'text'"
              [mainForm]="articleForm"
              [controlName]="'ean'"
              [placeholder]="eanPlaceholder"
              [ngClass]="{'placeholder-through': eanPlaceholder !== ''}"
              datatestid="eanInput"
            ></app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="articleForm" [controlName]="'name'" datatestid="nameInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.DESCRIPTION' | translateControl : form | async">
        <app-textarea [mainForm]="articleForm" [controlName]="'description'">
        </app-textarea>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.CATEGORY' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="articleForm" [controlName]="'category'" datatestid="categoryInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.UNIT' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="articleForm" [controlName]="'unit'" datatestid="unitInput">
        </app-input>
      </app-form-row>

      <app-form-row *ngIf="isDealer else manufacturerPriceRow"
        [label]="['FORMS.ARTICLE.LIST_PRICE', 'FORMS.ARTICLE.PURCHASE_PRICE'] | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="articleForm" [controlName]="'listPrice'" datatestid="listPriceInput">
            </app-input>
          </div>
          <div class="col-6">
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="articleForm" [controlName]="'purchasePrice'" datatestid="purchasePriceInput">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <ng-template #manufacturerPriceRow>
        <app-form-row [label]="['FORMS.ARTICLE.LIST_PRICE'] | translateControl : form | async">
          <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="articleForm" [controlName]="'listPrice'" datatestid="listPriceInput">
          </app-input>
        </app-form-row>
      </ng-template>

      <app-form-row
        [label]="['FORMS.ARTICLE.HEIGHT', 'FORMS.ARTICLE.WIDTH', 'FORMS.ARTICLE.DEPTH'] | translateControl : form | async">
        <div class="row">
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="articleForm" [controlName]="'height'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="articleForm" [controlName]="'width'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="articleForm" [controlName]="'depth'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.DIN' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="articleForm" [controlName]="'direction'" datatestid="directionInput">
        </app-input>
      </app-form-row>
    </div>

    <div class="form-section">
      <div class="collapseArea">
        <div class="collapseArea-trigger" aria-controls="collapseBasic" (click)="isCollapsed = !isCollapsed"
             [attr.aria-expanded]="!isCollapsed" [ngClass]="{'collapseArea-trigger_open': !isCollapsed}">
          <i svgIcon [icon]="'arrow'" [ngClass]="{'_open': !isCollapsed}"></i>
          {{'FORMS.POSITION.TEXT' | translate}}
          <app-tooltip
            [hasTooltip]="true"
            [insideModal]="true"
            [text]="'GENERAL.NO_POSITION_TEXT_XML' | translate">
                <span
                  svgIcon
                  [icon]="'info'"
                  [iconSize]="svgIconSizeMod.DEFAULT"
                  class="iconInfo"
                ></span>
          </app-tooltip>
        </div>
        <div [collapse]="isCollapsed" [isAnimated]="true">
          <div class="collapseArea-body" *ngIf="form.controls.positionTemplate">
            <app-dropdown [mainForm]="form" [controlName]="'positionTemplate'"
                          [options]="dropdownData.positionTemplates" [labelKey]="'name'" [valueKey]="'text'">
            </app-dropdown>

            <app-textarea [mainForm]="form" [controlName]="'text'">
            </app-textarea>
          </div>
        </div>
      </div>
    </div>

  </div>

</form>
